import React from "react";
import { NavLink, useLocation } from "react-router-dom";

interface LinkProps {
	to:
		| string
		| {
				modal?: string;
		  };
	activeClassName?: string;
}

const Link: React.FC<LinkProps & React.HTMLProps<HTMLAnchorElement>> = ({
	to,
	children,
	activeClassName,
	...rest
}) => {
	const location = useLocation();

	const isHref =
		typeof to === "string"
			? to.startsWith("http") || to.startsWith("www")
			: false;
	if (isHref) {
		return (
			<a
				{...(rest as any)}
				target="_blank"
				rel="noreferrer"
				href={to || "/"}
			>
				{children}
			</a>
		);
	}

	return (
		<NavLink
			target={rest?.target || undefined}
			className={rest?.className}
			to={(typeof to === "string" ? to : to?.modal) || "/"}
			state={
				typeof to !== "string" && to?.modal
					? {
							background: location,
					  }
					: undefined
			}
		>
			{children as any}
		</NavLink>
	);
};

export default Link;
